import { useRef } from "react";
import { capturePointer } from "../../lib/pointer";

export const Fader = ({ value, onChange, testId, height = 150, disabled }) => {
  const ref = useRef(null);
  const set = (y) => {
    const r = ref.current.getBoundingClientRect();
    onChange(Math.max(0, Math.min(1, Math.round((1 - (y - r.top) / r.height) * 100) / 100)));
  };
  const down = (e) => {
    if (disabled) return;
    e.preventDefault();
    capturePointer(ref.current, e.pointerId);
    set(e.clientY);
  };
  const move = (e) => { if (!disabled && ref.current.hasPointerCapture(e.pointerId)) set(e.clientY); };
  const key = (e) => {
    if (disabled) return;
    if (e.key === "ArrowUp") onChange(Math.min(1, +(value + 0.05).toFixed(2)));
    if (e.key === "ArrowDown") onChange(Math.max(0, +(value - 0.05).toFixed(2)));
  };
  return (
    <div
      ref={ref}
      role="slider"
      tabIndex={0}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(value * 100)}
      data-testid={testId}
      onPointerDown={down}
      onPointerMove={move}
      onKeyDown={key}
      className={`relative w-9 touch-none select-none outline-none focus-visible:ring-1 focus-visible:ring-yellow-400 rounded ${disabled ? "opacity-50" : "cursor-ns-resize"}`}
      style={{ height }}
    >
      <div className="absolute left-1/2 -translate-x-1/2 inset-y-1 w-1.5 rounded-full bg-black border border-zinc-800" />
      {[0, 0.25, 0.5, 0.75, 1].map((t) => (
        <div key={t} className="absolute right-0 h-px w-1.5 bg-zinc-600" style={{ top: `${t * 100}%` }} />
      ))}
      <div
        className="absolute left-0.5 right-0.5 h-6 -mt-3 rounded-[2px] border border-black bg-gradient-to-b from-zinc-200 via-zinc-400 to-zinc-600 shadow-[0_4px_8px_rgba(0,0,0,.6)]"
        style={{ top: `${(1 - value) * 100}%` }}
      >
        <div className="mx-auto mt-[10px] h-[2px] w-5 bg-yellow-400" />
      </div>
    </div>
  );
};
